import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box, Button, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Topbar = ({ onMenuClick }) => {
    const { logout, tenant } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#fff', borderBottom: '1px solid #e0e7ef', zIndex: 100 }}>
            <Toolbar>
                <IconButton edge="start" onClick={onMenuClick} sx={{ mr: 1, display: { md: 'none' } }}>
                    <MenuIcon />
                </IconButton>
                <Typography variant="subtitle1" color="text.secondary" sx={{ flexGrow: 1, fontWeight: 500 }}>
                    {tenant?.name}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Tooltip title="Notificações">
                        <IconButton size="small"><NotificationsNoneIcon sx={{ color: 'text.secondary' }} /></IconButton>
                    </Tooltip>
                    <Button startIcon={<LogoutIcon />} onClick={handleLogout} size="small" color="inherit" sx={{ color: 'text.secondary' }}>
                        Sair
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Topbar;
